import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import { useTranslation } from "react-i18next";

import './Room.css';
import featureActions from "../../../redux/feature/actions";



function Room() {
  // assets init
  const assetsPath = useSelector(state => state.Feature.assetsPath);
  const createButton = process.env.PUBLIC_URL + assetsPath + 'images/create.svg';
  const saveButton = process.env.PUBLIC_URL + assetsPath + 'images/save-button.svg';

  const userData = useSelector(state => state.Feature);
  const language = useSelector(state => state.Feature.language);

  useEffect(() => {
    dispatch(featureActions.getColoursRequest());

    if (userData.isLoggedIn == 1) {
      dispatch({type: featureActions.GET_OBJECTS_REQUEST});
    }else{

      if(localStorage.getItem("userData")){
        const userDataInLocalStroage = JSON.parse(localStorage.getItem("userData"));
        dispatch(featureActions.initUserData(userDataInLocalStroage));

        // force reload the canvas
        if(userDataInLocalStroage.coloursOnCanvas.length > 0) {
          const firstColour = userDataInLocalStroage.coloursOnCanvas[0];
          dispatch(featureActions.updatedColourDataDefine({
            order: 0,
            from: firstColour.id_product_attribute,
            to: firstColour.id_product_attribute
          }));

          setTimeout(function() {
            dispatch(featureActions.updateStatusOfUpdateColour(true));
          }, 500);
        }
      }

    }
  }, []);

  // get object
  const _isLoggedIn = useSelector((state) => state.Feature.isLoggedIn);
  const _objects = useSelector(state => state.Feature.userObjects);

  const _objectId = useSelector(state => state.Feature.selectedObjectId);
  const _objectName = useSelector(state => state.Feature.selectedObjectName);
  const _coloursOnCanvas = useSelector(state => state.Feature.coloursOnCanvas);
  const _priceData = useSelector(state => state.Feature.priceData);

  const dispatch = useDispatch();

  const setObject = () => {
    if (userData.isLoggedIn == 1) {
      const _payload = {
        objectId: _objectId,
        objectName: _objectName,
        object: {
          objectName: _objectName,
          userColours: [],
          coloursOnCanvas: _coloursOnCanvas,
          priceData: _priceData
        }
      }
      dispatch({type: featureActions.SET_OBJECTS_REQUEST, payload: _payload});
    }else{
      localStorage.setItem("userData", JSON.stringify(userData));
      dispatch({
        type: featureActions.OPEN_TOAST,
        payload: {
          isOpen: true,
          status: "success",
          message: "Object is saved successfully"
        },
      });
/*      const userData = JSON.parse(localStorage.getItem("userData"));*/
    }
  }

  const { t, i18n } = useTranslation();



  useEffect(() => {
    //if(_isLoggedIn == 1){}
    if(_isLoggedIn == 1){
    }
  }, [_isLoggedIn]);

  const [selectedObjectId, setSelectedObjectId] = useState(0);

  const handleChange = (e) => {
    const selectedId = e.target.value;
    setSelectedObjectId(selectedId);
    dispatch(featureActions.selectObject(selectedId));
  };

  useEffect(() => {
    //if(_isLoggedIn == 1){}
    if(_objects.length > 0){
      dispatch(featureActions.selectObject(_objects[0].objectId));
      // dispatch(featureActions.selectObject(_objects[1].objectId));
    }
  }, []);

  const createObject = () => {
    dispatch(featureActions.isOpenProjectModal());
  };
  
  const deleteObject = () => {
    const payload = {
      objectID: _objectId,
    }
    dispatch(featureActions.confirmModalActionDefine({
      type: featureActions.DELET_PROJECT_REQUEST,
      payload,
    }));

    dispatch(
      featureActions.isOpenConfirmModal()
    );
  }

  // const removeItem = (id) => {
  //   dispatch(statusActions.confirmModalActionDefine({
  //     type: featureActions.REMOVE_COLOUR_0N_CANVAS,
  //     payload: id,
  //   }));
  // }


  // Hide entire Projects block for guest users
  if (_isLoggedIn != 1) {
    return null;
  }

  return (
    <div className='acp-room acp-d-flex acp-space-between m-top acp-normal-font-style acp-p-bottom'>
      <div style={{fontWeight: 600, fontSize: "15px"}}>{t('Projects')}</div>
      <div className="acp-room-select-button-container acp-d-flex">
        <div className='acp-room-select-container acp-settings-lg'>
          <select className="acp-room-select" onChange={handleChange} value={selectedObjectId}>
            {
              _objects.map((item) => (
                <option key={item.objectId} value={item.objectId}>
                  {item.objectName}
                </option>
              ))
            }
          </select>
        </div>
        <div className="acp-d-flex">
          <div className="acp-button acp-settings-lg" onClick={setObject}>
            <img src={saveButton} alt='button' />
          </div>
          <div className="acp-button" onClick={createObject}>
            <img src={createButton} alt='button' />
          </div>
          <div className="acp-button acp-del-button" onClick={deleteObject}>
            <svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="white"  strokeWidth="2"  strokeLinecap="round"  strokeLinejoin="round"  className="icon icon-tabler icons-tabler-outline icon-tabler-trash"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M4 7l16 0" /><path d="M10 11l0 6" /><path d="M14 11l0 6" /><path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" /><path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" /></svg>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Room;